import React from "react";
import ReactDOM from "react-dom";
import AutoCompleteView from "./AutoCompleteView";

export default class AutoComplete {
    constructor(element) {
        this.element = element;
        this.view = element.querySelector("#js-autocomplete-root");
        this.init();
    }

    init() {
        ReactDOM.render(<AutoCompleteView />, document.getElementById("js-autocomplete-root"));
    }
}
